/*
 * @Author: Tina Huang
 * @Date: 2024-02-21 13:27:46
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-03-12 09:47:24
 * @Description:
 */

import { author } from '@/constants/author'
import { PlusOutlined } from '@ant-design/icons'
import { Avatar, Button, Card, Space } from 'antd'

export default function Author(props: { email?: boolean }) {
  const { email } = props
  return (
    <Card>
      <Card.Meta
        avatar={<Avatar src={author.avatar} />}
        title={
          <Space align="center">
            <span>{author.name}</span>
            <Button type="primary" size="small" icon={<PlusOutlined />} href={author.link} target="__blank">
              关注
            </Button>
          </Space>
        }
        description={
          <>
            <p>{author.desc}</p>
            {email && <p>📧: {author.email}</p>}
          </>
        }
      />
    </Card>
  )
}
